<template>
   <div id="ContainerClaim">
      <div class="row page-height">
        <div class="col-12">
            <MdTitleRegInfo
               v-bind:RegistrationInfo="PatientTitle"
               v-bind:titlePrefix="this.Mode ? $t('PatientClaimList.PatientClaimEdit'): $t('PatientClaimList.PatientClaimAdd')"
               v-bind:IsClinical="false"
               v-bind:titleRef="'titleElementPatientClaim'"
               v-bind:patientCode="this.PatientCode || this.$route.params.id">
            </MdTitleRegInfo>

            <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
               <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
               <div class="flex-grow-1">
                  <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
               </div>
            </div>


            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit
                        v-bind:Label="$t('PatientClaimList.IssLineNo')"
                        v-bind:TypeProp="'text'"
                        v-bind:Name="'IssLineNo'"
                        v-model="Claim.issLineNo"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_claim_issLineNo'">
                    </MdEdit>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                        <MdDateTime
                        :Label="$t('Shared.datefrom')"
                        :Model="Claim.dateFrom"
                        @input="Claim.dateFrom = $event"
                        :Id="'PatientClaimDateFrom'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="isReadOnly">
                    </MdDateTime>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                        <MdDateTime
                        :Label="$t('Shared.dateTo')"
                        :Model="Claim.dateTo"
                        @input="Claim.dateTo = $event"
                        :Id="'PatientClaimDateTo'"
                        :Type="'date'"
                        :isRequired="false"
                        :isConfirm="false"
                        :ReadOnly="isReadOnly">
                    </MdDateTime>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="Claim.posCode"
                        v-bind:ModelDescription="PosDescription"
                        v-bind:Label="$t('PatientClaimList.Pos')"
                        v-bind:RefCode="'PlaceOfServicesPos'"
                        v-bind:Api="'PlaceOfServices'"
                        v-bind:FieldCode="'code'"
                        v-bind:Fields="[]"
                        v-bind:FieldDescription="'description'"
                        :IsDisabled="isReadOnly"
                        :SearchTitle="$t('PatientClaimList.Pos')"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'code'"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="Claim.cptHcpcs"
                        v-bind:ModelDescription="cptHcpcsDescription"
                        v-bind:Label="$t('PatientClaimList.CPTREVCODE')"
                        v-bind:RefCode="'CPTs'"
                        v-bind:Api="'CPTs'"
                        v-bind:Fields="[]"
                        v-bind:FieldCode="'code'"
                        v-bind:isRequired="true"
                        v-bind:isValid="isCptHcpcsValid"
                        v-bind:FieldDescription="'name'"
                        :IsDisabled="isReadOnly"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'code'"/>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="Claim.hcpcsCode"
                        v-bind:ModelDescription="Claim.hcpcsDescription"
                        v-bind:Label="$t('Shared.HCPCS')"
                        v-bind:RefCode="'HCPCS'"
                        v-bind:Api="'CPTs'"
                        v-bind:Fields="[]"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'name'"
                        :IsDisabled="isReadOnly"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'code'"/>
                </b-col>

                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="Claim.modifier1"
                        v-bind:ModelDescription="Claim.modifier1Description"
                        v-bind:Label="$t('Shared.Modifier1')"
                        v-bind:RefCode="'Modifier1'"
                        v-bind:Api="'Modifiers'"
                        v-bind:Fields="[]"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'description'"
                        :IsDisabled="isReadOnly"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'code'"/>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="Claim.modifier2"
                        v-bind:ModelDescription="Claim.modifier2Description"
                        v-bind:Label="$t('Shared.Modifier2')"
                        v-bind:RefCode="'Modifier2'"
                        v-bind:Api="'Modifiers'"
                        v-bind:Fields="[]"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'description'"
                        :IsDisabled="isReadOnly"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'code'"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="Claim.modifier3"
                        v-bind:ModelDescription="Claim.modifier3Description"
                        v-bind:Label="$t('PatientClaimList.Modifier3')"
                        v-bind:RefCode="'Modifier3'"
                        v-bind:Api="'Modifiers'"
                        v-bind:Fields="[]"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'description'"
                        :IsDisabled="isReadOnly"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'code'"/>
                </b-col>

                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="Claim.modifier4"
                        v-bind:ModelDescription="Claim.modifier4Description"
                        v-bind:Label="$t('PatientClaimList.Modifier4')"
                        v-bind:RefCode="'Modifier4'"
                        v-bind:Api="'Modifiers'"
                        v-bind:Fields="[]"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'description'"
                        :IsDisabled="isReadOnly"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'code'"/>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit
                        v-bind:Label="$t('Shared.Day')"
                        v-bind:TypeProp="'number'"
                        v-bind:Name="'Name'"
                        v-model.number="Claim.dayUnit"
                        v-bind:isRequired="true"
                        v-bind:isValid="isDayUnitValid"
                        v-bind:isReadOnly="isReadOnly"
                        v-on:change="ChangeDay"
                        v-bind:Id="'input_r_nameDay'">
                    </MdEdit>
                </b-col>

                <b-col lg="3" md="3" sm="12">
                    <MdEdit
                        v-bind:Label="$t('Shared.UnitPrice')"
                        v-bind:TypeProp="'number'"
                        v-bind:Name="'Name'"
                        v-model.number="Claim.unitPrice"
                        v-bind:isRequired="true"
                        v-bind:isValid="isUnitPriceValid"
                        v-bind:isReadOnly="isReadOnly"
                        v-on:change="ChangeUnit"
                        v-bind:Id="'input_r_nameUnit'">
                    </MdEdit>
                </b-col>
            </b-row>

            <b-row>

                <b-col lg="3" md="3" sm="12">
                    <MdEdit
                        v-bind:Label="$t('Shared.Charges')"
                        v-bind:TypeProp="'number'"
                        v-bind:Name="'Name'"
                        v-bind:StepProp="'0.01'"
                        v-money-prefix
                        v-model.number="Claim.charges"
                        v-bind:isRequired="true"
                        v-bind:isValid="isChargesValid"
                        v-bind:isReadOnly="true"
                        v-bind:Id="'input_r_nameCharges'">
                    </MdEdit>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="Claim.valueCode"
                        v-bind:ModelDescription="Claim.valueCodeDescription"
                        v-bind:Label="$t('Shared.ValueCode')"
                        v-bind:RefCode="'ValueCodes'"
                        v-bind:Api="'ValueCodes'"
                        v-bind:Fields="[]"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'shortDescription'"
                        :IsDisabled="isReadOnly"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'code'"/>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit
                        v-bind:Label="$t('Shared.AmountValCode')"
                        v-bind:TypeProp="'number'"
                        v-bind:Name="'Name'"
                        v-model.number="Claim.valueCodeAmt"
                        v-bind:isReadOnly="isReadOnly"
                        v-bind:Id="'input_r_namePaid'">
                    </MdEdit>
                </b-col>

            </b-row>

            <b-row>

                <b-col lg="3" md="3" sm="12">
                    <MdEdit
                        v-bind:Label="$t('PatientClaimList.CLIA')"
                        v-bind:TypeProp="'text'"
                        v-bind:Name="'Name'"
                        v-bind:MaxLengthProp="20"
                        v-model="Claim.clia"
                        v-bind:isReadOnly="isReadOnly"
                        v-bind:Id="'input_r_nameClia'">
                    </MdEdit>
                </b-col>

                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="$t('PatientClaimList.DocInd')"
                        v-bind:Options="DocIndList"
                        v-bind:Model="Claim.docInd"
                        v-bind:IsDisabled="isReadOnly"
                        v-bind:AllowEmpty="true"
                        v-bind:FieldDescription="'text'"
                        v-bind:FieldCode="'value'"
                        :Input="ChangeDropDownDocInd"/>
                </b-col>

                <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('PatientClaimList.DiagCode')"
                            v-bind:Options="DiagList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:isRequired="true"
                            v-bind:isValid="isDiagCodeValid"
                            v-bind:Model="Claim.diagCode"
                            v-bind:Multiple="false"
                            v-bind:IsDisabled="isReadOnly"
                            :Input="ChangeDropDownDiag"/>
                </b-col>

                <b-col md="auto" sm="12">
                    <MdButton
                    v-bind:Label="$t('Shared.Diagnosis')"
                    v-bind:Name="'ClaimDiagnosis'"
                    v-bind:ClassProp="'secondary btn-login mt-3'"
                    v-on:click="OpenDiagnosis"/>
                </b-col>
            </b-row>

             <div class="IncidentContainerBox noNum mt-2" v-if="IsNarrative">
                <div class="row">
                <div class="col-md-12">
                    <div class="grid-margin stretch-card">
                    <div class="card activeCard">
                        <div class="card-body">
                        <div
                            class="d-flex align-items-start justify-content-between">
                            <h6 v-b-toggle="'Narrative'" class="card-title flex-grow lower-line text-truncate">
                                {{$t('PatientClaimList.Narrative')}}
                            </h6>
                            </div>
                            <b-collapse visible id="Narrative" class="small-info ml-2"><small>{{$t('PatientClaimList.clickTitleTextNarrative')}}</small></b-collapse>
                        <b-collapse id="Narrative">



                            <div class="card activeCard">
                                <div class="container-mars">
                                    <div class="card-container">
                                        <div class="card-body">
                                            <b-row>
                                                <b-col md="12">
                                                    <MdMemo
                                                        v-bind:Label="$tc('Shared.Note', 2)"
                                                        v-bind:TypeProp="'text'"
                                                        v-bind:Name="'notes'"
                                                        v-bind:Rows="'3'"
                                                        v-bind:MaxRows="'6'"
                                                        v-bind:MaxLength="'500'"
                                                        v-model="Claim.narrative"
                                                        v-bind:isReadOnly="isReadOnly">
                                                    </MdMemo>
                                                </b-col>
                                            </b-row>

                                        </div>
                                    </div>
                                </div>
                            </div>

                    </b-collapse>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>



            <div class="IncidentContainerBox noNum mt-2">
                <div class="row">
                <div class="col-md-12">
                    <div class="grid-margin stretch-card">
                    <div class="card activeCard">
                        <div class="card-body">
                        <div
                            class="d-flex align-items-start justify-content-between">
                            <h6 v-b-toggle="'PatientInformation'" class="card-title flex-grow lower-line text-truncate">
                                {{$t('Shared.PatientInfo')}}
                            </h6>
                            </div>
                            <b-collapse visible id="PatientInformation" class="small-info ml-2"><small>{{$t('modalMarsMed.clickTitleTextPatient')}}</small></b-collapse>
                        <b-collapse id="PatientInformation">



                            <div class="card activeCard">
                                <div class="container-mars">
                                    <div class="card-container">
                                        <div class="card-body">

                                                    <b-row class="groupingRow">
                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:ModelCode="Claim.insuranceCode"
                                                            v-bind:ModelDescription="Claim.insuranceCodeDescription"
                                                            v-bind:Label="$t('Shared.PrimaryInsurance')"
                                                            v-bind:RefCode="'PrimaryInsurance'"
                                                            v-bind:Api="'Insurances'"
                                                            v-bind:Fields="[]"
                                                            v-bind:FieldCode="'insurancecode'"
                                                            v-bind:FieldDescription="'company'"
                                                            :IsDisabled="isReadOnly"
                                                            :GetValues="onCodeConditionOk"
                                                            :SearchFieldCode="'code'"/>
                                                    </b-col>

                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdEdit
                                                            v-bind:Label="$t('Shared.PrimInsuranceNo')"
                                                            v-bind:TypeProp="'text'"
                                                            v-bind:Name="'Name'"
                                                            v-bind:MaxLengthProp="20"
                                                            v-model="Claim.primInsuranceNo"
                                                            v-bind:isReadOnly="isReadOnly"
                                                            v-bind:Id="'input_r_namePrimInsuNo'">
                                                        </MdEdit>
                                                    </b-col>
                                                    </b-row>
                                                    <b-row class="groupingRow">

                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:ModelCode="Claim.insuranceCode1"
                                                            v-bind:ModelDescription="Claim.insuranceCode1Description"
                                                            v-bind:Label="$t('Shared.SecondaryInsurance')"
                                                            v-bind:RefCode="'SecInsurance'"
                                                            v-bind:Api="'Insurances'"
                                                            v-bind:Fields="[]"
                                                            v-bind:FieldCode="'insurancecode'"
                                                            v-bind:FieldDescription="'company'"
                                                            :IsDisabled="isReadOnly"
                                                            :GetValues="onCodeConditionOk"
                                                            :SearchFieldCode="'code'"/>
                                                    </b-col>
                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdEdit
                                                            v-bind:Label="$t('PatientClaimList.SecondaryInsuranceNo')"
                                                            v-bind:TypeProp="'text'"
                                                            v-bind:Name="'Name'"
                                                            v-bind:MaxLengthProp="20"
                                                            v-model="Claim.secInsuranceNo"
                                                            v-bind:isReadOnly="isReadOnly"
                                                            v-bind:Id="'input_r_nameSecInsuNo'">
                                                        </MdEdit>
                                                    </b-col>
                                                    </b-row>
                                                    <b-row class="groupingRow">
                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:ModelCode="Claim.insuranceCode2"
                                                            v-bind:ModelDescription="Claim.insuranceCode2Description"
                                                            v-bind:Label="$t('PatientClaimList.TertiaryInsurance')"
                                                            v-bind:RefCode="'TerInsurance'"
                                                            v-bind:Api="'Insurances'"
                                                            v-bind:Fields="[]"
                                                            v-bind:FieldCode="'insurancecode'"
                                                            v-bind:FieldDescription="'company'"
                                                            :IsDisabled="isReadOnly"
                                                            :GetValues="onCodeConditionOk"
                                                            :SearchFieldCode="'code'"/>
                                                    </b-col>
                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdEdit
                                                            v-bind:Label="$t('PatientClaimList.TertiaryInsuranceNo')"
                                                            v-bind:TypeProp="'text'"
                                                            v-bind:Name="'Name'"
                                                            v-bind:MaxLengthProp="20"
                                                            v-model="Claim.terInsuranceNo"
                                                            v-bind:isReadOnly="isReadOnly"
                                                            v-bind:Id="'input_r_nameTerInsuNo'">
                                                        </MdEdit>
                                                    </b-col>
                                                    </b-row>
                                                    <b-row>
                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:ModelCode="Claim.doctorCode"
                                                            v-bind:ModelDescription="DoctorDescription"
                                                            v-bind:Label="$t('Shared.Provider')"
                                                            v-bind:RefCode="'Doctors'"
                                                            v-bind:Fields="[]"
                                                            v-bind:Api="'Doctors'"
                                                            v-bind:FieldCode="'code'"
                                                            v-bind:FieldDescription="'name'"
                                                            :IsDisabled="isReadOnly"
                                                            :GetValues="onCodeConditionOk"
                                                            :SearchFieldCode="'code'"/>
                                                    </b-col>

                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:ModelCode="Claim.doctorCodeRef"
                                                            v-bind:ModelDescription="DoctorCodeRefDescription"
                                                            v-bind:Label="$t('PatientClaimList.ReferralProvider')"
                                                            v-bind:RefCode="'DoctorsRef'"
                                                            v-bind:Api="'Doctors'"
                                                            v-bind:Fields="[]"
                                                            v-bind:FieldCode="'code'"
                                                            v-bind:FieldDescription="'name'"
                                                            :IsDisabled="isReadOnly"
                                                            :GetValues="onCodeConditionOk"
                                                            :SearchFieldCode="'code'"/>
                                                    </b-col>
                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:ModelCode="Claim.facilityCode"
                                                            v-bind:ModelDescription="FacilityDescription"
                                                            v-bind:Label="$t('Shared.Facility')"
                                                            v-bind:RefCode="'Facilities'"
                                                            v-bind:Api="'Facilities'"
                                                            v-bind:Fields="[]"
                                                            v-bind:FieldCode="'code'"
                                                            v-bind:FieldDescription="'company'"
                                                            :IsDisabled="isReadOnly"
                                                            :GetValues="onCodeConditionOk"
                                                            :SearchFieldCode="'code'"/>
                                                    </b-col>
                                                    </b-row>

                                        </div>
                                    </div>
                                </div>
                            </div>

                    </b-collapse>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>


            <div class="IncidentContainerBox noNum mt-2">
                <div class="row">
                <div class="col-md-12">
                    <div class="grid-margin stretch-card">
                    <div class="card activeCard">
                        <div class="card-body">
                        <div
                            class="d-flex align-items-start justify-content-between">
                            <h6 v-b-toggle="'InfoBoxs'" class="card-title flex-grow lower-line text-truncate">
                                {{ $t('PatientClaimList.AditionalInformation') }}
                            </h6>
                            </div>
                            <b-collapse visible id="InfoBoxs" class="small-info ml-2"><small>{{$t('PatientClaimList.clickTitleTextAdditional')}}</small></b-collapse>
                        <b-collapse id="InfoBoxs">



                            <div class="card activeCard">
                                <div class="container-mars">
                                    <div class="card-container">
                                        <div class="card-body">
                                            <div class="row patPhoto-container">

                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{ $t('Patient.Emergency') }}</small><br>
                                                            <b>{{patient.emergency ? $t('Shared.TitleYes') : $t('Shared.TitleNo')}}</b>
                                                        </div>
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{ $t('PatientClaimList.ReleaseTo1ST') }}</small><br>
                                                            <b>{{patient.infoRelease === 'Y' ? $t('Shared.TitleYes') : $t('Shared.TitleNo')}}</b>
                                                        </div>
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{ $t('PatientClaimList.AcctAssigment') }}</small><br>
                                                            <b>{{patient.acceptAssign === 'Y' ? $t('Shared.TitleYes') : $t('Shared.TitleNo')}}</b>
                                                        </div>
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{ $t('Patient.Deceased') }}</small><br>
                                                            <b>{{patient.deceased === 'Y' ? $t('Shared.TitleYes') : $t('Shared.TitleNo')}}</b>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{ $t('PatientClaimList.AmtBillet') }}</small><br>
                                                            <b>{{Info.AmtBillet}}</b>
                                                        </div>
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{$t('PatientClaimList.AmtPay')}}</small><br>
                                                            <b>{{Info.AmtPay}}</b>
                                                        </div>
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{$t('Shared.Balance')}}</small><br>
                                                            <b>{{Info.Balance}}</b>
                                                        </div>
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{$tc('PatientClaimList.AssignDate')}}</small><br>
                                                            <b>{{patient.sgDate}}</b>
                                                        </div>
                                                    </div>


                                                        <div class="row">
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{ $t('Shared.RelToEmployment') }}</small><br>
                                                            <b>{{patient.relatedToEmp ? $t('Shared.TitleYes') : $t('Shared.TitleNo')}}</b>
                                                        </div>
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{$t('Shared.RelatedToAutoAccident')}}</small><br>
                                                            <b>{{patient.relatedToAuto ? $t('Shared.TitleYes') : $t('Shared.TitleNo')}}</b>
                                                        </div>
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{$t('Shared.State')}}</small><br>
                                                            <b>{{patient.accState}}</b>
                                                        </div>
                                                        <div class="col-md-3 text-muted p-item">
                                                            <small>{{$tc('PatientClaimList.AccidentDate')}}</small><br>
                                                            <b>{{patient.consultDate}}</b>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                    </b-collapse>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>


             <div :class="'IncidentContainerBox noNum mt-2'">
                <div class="row">
                <div class="col-md-12">
                    <div class="grid-margin stretch-card">
                    <div class="card activeCard">
                        <div class="card-body">
                        <div
                            class="d-flex align-items-start justify-content-between">
                            <h6 v-b-toggle="'OccurrenceAutorization'" class="card-title flex-grow lower-line text-truncate">
                                {{ $t('PatientClaimList.OccurrenceAutorization') }}
                            </h6>
                            </div>
                            <b-collapse visible id="OccurrenceAutorization" class="small-info ml-2"><small>{{$t('PatientClaimList.clickTitleTextOccurrence')}}</small></b-collapse>
                        <b-collapse id="OccurrenceAutorization">



                            <div class="card activeCard">
                                <div class="container-mars">
                                    <div class="card-container">
                                        <div class="card-body">
                                             <MdTitle v-bind:Text="'Conditions'" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'" v-bind:StyleProp="'margin: 0 !important;'"/>
                                                <b-row>
                                                <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:Label="$t('Patient.Condition', {'num': '1'})"
                                                            v-bind:ModelCode="Claim.conditionCode1"
                                                            v-bind:ModelDescription="Claim.conditionCode1Description"
                                                            v-bind:RefCode="'Condition1'"
                                                            v-bind:Api="'conditions'"
                                                            v-bind:FieldCode="'code'"
                                                            v-bind:Fields="[]"
                                                            v-bind:FieldDescription="'shortDescription'"
                                                            :IsDisabled="isReadOnly"
                                                            :SearchTitle="$t('Patient.Conditions')"
                                                            :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '1'})"
                                                            v-bind:isConcatModalId="true"
                                                            v-bind:ConcatModalId="'iModalClaimCondition1'"
                                                            :GetValues="onCodeConditionOkModal"
                                                            :SearchFieldCode="'Code'"
                                                        />
                                                    </b-col>
                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:Label="$t('Patient.Condition', {'num': '2'})"
                                                            v-bind:ModelCode="Claim.conditionCode2"
                                                            v-bind:ModelDescription="Claim.conditionCode2Description"
                                                            v-bind:RefCode="'Condition2'"
                                                            v-bind:Api="'conditions'"
                                                            v-bind:FieldCode="'code'"
                                                            v-bind:Fields="[]"
                                                            v-bind:FieldDescription="'shortDescription'"
                                                            :IsDisabled="isReadOnly"
                                                            :SearchTitle="$t('Patient.Conditions')"
                                                            :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '2'})"
                                                            v-bind:isConcatModalId="true"
                                                            v-bind:ConcatModalId="'iModalClaimCondition2'"
                                                            :GetValues="onCodeConditionOkModal"
                                                            :SearchFieldCode="'Code'"
                                                        />
                                                    </b-col>
                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:Label="$t('Patient.Condition', {'num': '3'})"
                                                            v-bind:ModelCode="Claim.conditionCode3"
                                                            v-bind:ModelDescription="Claim.conditionCode3Description"
                                                            v-bind:RefCode="'Condition3'"
                                                            v-bind:Api="'conditions'"
                                                            v-bind:FieldCode="'code'"
                                                            v-bind:Fields="[]"
                                                            v-bind:FieldDescription="'shortDescription'"
                                                            :IsDisabled="isReadOnly"
                                                            :SearchTitle="$t('Patient.Conditions')"
                                                            :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '3'})"
                                                            v-bind:isConcatModalId="true"
                                                            v-bind:ConcatModalId="'iModalClaimCondition3'"
                                                            :GetValues="onCodeConditionOkModal"
                                                            :SearchFieldCode="'Code'"
                                                        />
                                                    </b-col>
                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:Label="$t('Patient.Condition', {'num': '4'})"
                                                            v-bind:ModelCode="Claim.conditionCode4"
                                                            v-bind:ModelDescription="Claim.conditionCode4Description"
                                                            v-bind:RefCode="'Condition4'"
                                                            v-bind:Api="'conditions'"
                                                            v-bind:FieldCode="'code'"
                                                            v-bind:FieldDescription="'shortDescription'"
                                                            :IsDisabled="isReadOnly"
                                                            v-bind:Fields="[]"
                                                            :SearchTitle="$t('Patient.Conditions')"
                                                            :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '4'})"
                                                            v-bind:isConcatModalId="true"
                                                            v-bind:ConcatModalId="'iModalClaimCondition4'"
                                                            :GetValues="onCodeConditionOkModal"
                                                            :SearchFieldCode="'Code'"
                                                        />
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:Label="$t('Patient.Condition', {'num': '5'})"
                                                            v-bind:ModelCode="Claim.conditionCode5"
                                                            v-bind:ModelDescription="Claim.conditionCode5Description"
                                                            v-bind:RefCode="'Condition5'"
                                                            v-bind:Api="'conditions'"
                                                            v-bind:Fields="[]"
                                                            v-bind:FieldCode="'code'"
                                                            v-bind:FieldDescription="'shortDescription'"
                                                            :IsDisabled="isReadOnly"
                                                            :SearchTitle="$t('Patient.Conditions')"
                                                            :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '5'})"
                                                            v-bind:isConcatModalId="true"
                                                            v-bind:ConcatModalId="'iModalClaimCondition5'"
                                                            :GetValues="onCodeConditionOkModal"
                                                            :SearchFieldCode="'Code'"
                                                        />
                                                    </b-col>
                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:Label="$t('Patient.Condition', {'num': '6'})"
                                                            v-bind:ModelCode="Claim.conditionCode6"
                                                            v-bind:ModelDescription="Claim.conditionCode6Description"
                                                            v-bind:RefCode="'Condition6'"
                                                            v-bind:Api="'conditions'"
                                                            v-bind:FieldCode="'code'"
                                                            v-bind:FieldDescription="'shortDescription'"
                                                            :IsDisabled="isReadOnly"
                                                            v-bind:Fields="[]"
                                                            :SearchTitle="$t('Patient.Conditions')"
                                                            :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '6'})"
                                                            v-bind:isConcatModalId="true"
                                                            v-bind:ConcatModalId="'iModalClaimCondition6'"
                                                            :GetValues="onCodeConditionOkModal"
                                                            :SearchFieldCode="'Code'"
                                                        />
                                                    </b-col>
                                                    <b-col lg="3" md="3" sm="12">
                                                        <MdLookup
                                                            v-bind:Label="$t('Patient.Condition', {'num': '7'})"
                                                            v-bind:ModelCode="Claim.conditionCode7"
                                                            v-bind:ModelDescription="Claim.conditionCode7Description"
                                                            v-bind:RefCode="'Condition7'"
                                                            v-bind:Api="'conditions'"
                                                            v-bind:FieldCode="'code'"
                                                            v-bind:FieldDescription="'shortDescription'"
                                                            :IsDisabled="isReadOnly"
                                                            v-bind:Fields="[]"
                                                            :SearchTitle="$t('Patient.Conditions')"
                                                            :InvalidFeedback="$t('Patient.InvalidConditionCode',{'num': '7'})"
                                                            v-bind:isConcatModalId="true"
                                                            v-bind:ConcatModalId="'iModalClaimCondition7'"
                                                            :GetValues="onCodeConditionOkModal"
                                                            :SearchFieldCode="'Code'"
                                                        />
                                                    </b-col>
                                                </b-row>

                                             <MdTitle v-bind:Text="'Occurrence Code'"  class="mb-1" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                                                    <b-row>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 1'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencecode1"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencecode1description"
                                                                v-bind:RefCode="'Occurrence1'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldCode="'code'"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 1'"
                                                                v-bind:isConcatModalId="true"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrence1'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"
                                                            />
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.Date1')"
                                                                    :Model="Claim.occurrence.occurencedate1"
                                                                    @input="Claim.occurrence.occurencedate1 = $event"
                                                                    :Id="'OccuDate1'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 2'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencecode2"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencecode2description"
                                                                v-bind:RefCode="'Occurrence2'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 2'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrence2'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"
                                                            />
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.Date2')"
                                                                    :Model="Claim.occurrence.occurencedate2"
                                                                    @input="Claim.occurrence.occurencedate2 = $event"
                                                                    :Id="'OccuDate2'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>

                                                    <b-row>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 3'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencecode3"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencecode3description"
                                                                v-bind:RefCode="'Occurrence3'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 3'"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:isConcatModalId="true"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrence3'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"
                                                            />
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.Date3')"
                                                                    :Model="Claim.occurrence.occurencedate3"
                                                                    @input="Claim.occurrence.occurencedate3 = $event"
                                                                    :Id="'OccuDate3'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 4'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencecode4"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencecode4description"
                                                                v-bind:RefCode="'Occurrence4'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldCode="'code'"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 4'"
                                                                v-bind:isConcatModalId="true"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrence4'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"
                                                            />
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.Date4')"
                                                                    :Model="Claim.occurrence.occurencedate4"
                                                                    @input="Claim.occurrence.occurencedate4 = $event"
                                                                    :Id="'OccuDate4'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>

                                                        <b-row>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 5'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencecode5"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencecode5description"
                                                                v-bind:RefCode="'Occurrence5'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 5'"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:isConcatModalId="true"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrence5'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"
                                                            />
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                        <MdDateTime
                                                                    :Label="$t('PatientClaimList.Date5')"
                                                                    :Model="Claim.occurrence.occurencedate5"
                                                                    @input="Claim.occurrence.occurencedate5 = $event"
                                                                    :Id="'OccuDate5'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 6'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencecode6"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencecode6description"
                                                                v-bind:RefCode="'Occurrence6'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 6'"
                                                                v-bind:Fields="[]"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:isConcatModalId="true"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrence6'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"
                                                            />
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                        <MdDateTime
                                                                    :Label="$t('PatientClaimList.Date6')"
                                                                    :Model="Claim.occurrence.occurencedate6"
                                                                    @input="Claim.occurrence.occurencedate6 = $event"
                                                                    :Id="'OccuDate6'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>

                                                    <b-row>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 7'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencecode7"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencecode7description"
                                                                v-bind:RefCode="'Occurrence7'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 7'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrence7'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"
                                                            />
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                        <MdDateTime
                                                                    :Label="$t('PatientClaimList.Date7')"
                                                                    :Model="Claim.occurrence.occurencedate7"
                                                                    @input="Claim.occurrence.occurencedate7 = $event"
                                                                    :Id="'OccuDate7'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 8'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencecode8"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencecode8description"
                                                                v-bind:RefCode="'Occurrence8'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 8'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrence8'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"
                                                            />
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                        <MdDateTime
                                                                    :Label="$t('PatientClaimList.Date8')"
                                                                    :Model="Claim.occurrence.occurencedate8"
                                                                    @input="Claim.occurrence.occurencedate8 = $event"
                                                                    :Id="'OccuDate8'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>

                                                    <b-row>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 9'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencecode9"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencecode9description"
                                                                v-bind:RefCode="'Occurrence9'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 9'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrence9'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"
                                                            />
                                                        </b-col>
                                                        <b-col lg="3" md="3" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.Date9')"
                                                                    :Model="Claim.occurrence.occurencedate9"
                                                                    @input="Claim.occurrence.occurencedate9 = $event"
                                                                    :Id="'OccuDate9'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>

                                                     <MdTitle v-bind:Text="'Occurrence Span'"  class="mb-1" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 1'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode1"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode1description"
                                                                v-bind:RefCode="'Ospan1'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 1'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrencespan1'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom1')"
                                                                    :Model="Claim.occurrence.occurencedatefrom1"
                                                                    @input="Claim.occurrence.occurencedatefrom1 = $event"
                                                                    :Id="'DateFrom1'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo1')"
                                                                    :Model="Claim.occurrence.occurencedateto1"
                                                                    @input="Claim.occurrence.occurencedateto1 = $event"
                                                                    :Id="'DateTo1'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 2'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode2"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode2description"
                                                                v-bind:RefCode="'Ospan2'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 2'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrenceSpan2'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom2')"
                                                                    :Model="Claim.occurrence.occurencedatefrom2"
                                                                    @input="Claim.occurrence.occurencedatefrom2 = $event"
                                                                    :Id="'DateFrom2'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo2')"
                                                                    :Model="Claim.occurrence.occurencedateto2"
                                                                    @input="Claim.occurrence.occurencedateto2 = $event"
                                                                    :Id="'DateTo2'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 3'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode3"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode3description"
                                                                v-bind:RefCode="'Ospan3'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 3'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrencespan3'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom3')"
                                                                    :Model="Claim.occurrence.occurencedatefrom3"
                                                                    @input="Claim.occurrence.occurencedatefrom3 = $event"
                                                                    :Id="'DateFrom3'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo3')"
                                                                    :Model="Claim.occurrence.occurencedateto3"
                                                                    @input="Claim.occurrence.occurencedateto3 = $event"
                                                                    :Id="'DateTo3'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 4'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode4"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode4description"
                                                                v-bind:RefCode="'Ospan4'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 4'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrencespan4'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom4')"
                                                                    :Model="Claim.occurrence.occurencedatefrom4"
                                                                    @input="Claim.occurrence.occurencedatefrom4 = $event"
                                                                    :Id="'DateFrom4'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo4')"
                                                                    :Model="Claim.occurrence.occurencedateto4"
                                                                    @input="Claim.occurrence.occurencedateto4 = $event"
                                                                    :Id="'DateTo4'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 5'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode5"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode5description"
                                                                v-bind:RefCode="'Ospan5'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 5'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrencespan5'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom5')"
                                                                    :Model="Claim.occurrence.occurencedatefrom5"
                                                                    @input="Claim.occurrence.occurencedatefrom5 = $event"
                                                                    :Id="'DateFrom5'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo5')"
                                                                    :Model="Claim.occurrence.occurencedateto5"
                                                                    @input="Claim.occurrence.occurencedateto5 = $event"
                                                                    :Id="'DateTo5'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 6'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode6"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode6description"
                                                                v-bind:RefCode="'Ospan6'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 6'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrencespan6'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom6')"
                                                                    :Model="Claim.occurrence.occurencedatefrom6"
                                                                    @input="Claim.occurrence.occurencedatefrom6 = $event"
                                                                    :Id="'DateFrom6'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo6')"
                                                                    :Model="Claim.occurrence.occurencedateto6"
                                                                    @input="Claim.occurrence.occurencedateto6 = $event"
                                                                    :Id="'DateTo6'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 7'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode7"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode7description"
                                                                v-bind:RefCode="'Ospan7'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 7'"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:isConcatModalId="true"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrenceSpan7'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom7')"
                                                                    :Model="Claim.occurrence.occurencedatefrom7"
                                                                    @input="Claim.occurrence.occurencedatefrom7 = $event"
                                                                    :Id="'DateFrom7'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo7')"
                                                                    :Model="Claim.occurrence.occurencedateto7"
                                                                    @input="Claim.occurrence.occurencedateto7 = $event"
                                                                    :Id="'DateTo7'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 8'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode8"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode8description"
                                                                v-bind:RefCode="'Ospan8'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:Fields="[]"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 8'"
                                                                v-bind:isConcatModalId="true"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrenceSpan8'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom8')"
                                                                    :Model="Claim.occurrence.occurencedatefrom8"
                                                                    @input="Claim.occurrence.occurencedatefrom8 = $event"
                                                                    :Id="'DateFrom8'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo8')"
                                                                    :Model="Claim.occurrence.occurencedateto8"
                                                                    @input="Claim.occurrence.occurencedateto8 = $event"
                                                                    :Id="'DateTo8'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 9'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode8"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode9description"
                                                                v-bind:RefCode="'Ospan9'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldCode="'code'"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 9'"
                                                                v-bind:isConcatModalId="true"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrenceSpan9'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom9')"
                                                                    :Model="Claim.occurrence.occurencedatefrom9"
                                                                    @input="Claim.occurrence.occurencedatefrom9 = $event"
                                                                    :Id="'DateFrom9'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo9')"
                                                                    :Model="Claim.occurrence.occurencedateto9"
                                                                    @input="Claim.occurrence.occurencedateto9= $event"
                                                                    :Id="'DateTo9'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 10'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode10"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode10description"
                                                                v-bind:RefCode="'Ospan10'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 10'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrenceSpan10'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom10')"
                                                                    :Model="Claim.occurrence.occurencedatefrom10"
                                                                    @input="Claim.occurrence.occurencedatefrom10 = $event"
                                                                    :Id="'DateFrom10'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo10')"
                                                                    :Model="Claim.occurrence.occurencedateto10"
                                                                    @input="Claim.occurrence.occurencedateto10= $event"
                                                                    :Id="'DateTo10'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 11'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode11"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode11description"
                                                                v-bind:RefCode="'Ospan11'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 11'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrenceSpan11'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom11')"
                                                                    :Model="Claim.occurrence.occurencedatefrom11"
                                                                    @input="Claim.occurrence.occurencedatefrom11 = $event"
                                                                    :Id="'DateFrom11'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo11')"
                                                                    :Model="Claim.occurrence.occurencedateto11"
                                                                    @input="Claim.occurrence.occurencedateto11= $event"
                                                                    :Id="'DateTo11'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdLookup
                                                                v-bind:Label="$t('Shared.Code')+' 12'"
                                                                v-bind:ModelCode="Claim.occurrence.occurencespancode12"
                                                                v-bind:ModelDescription="Claim.occurrence.occurencespancode12description"
                                                                v-bind:RefCode="'Ospan12'"
                                                                v-bind:Api="'Occurrences'"
                                                                v-bind:FieldCode="'code'"
                                                                v-bind:Fields="[]"
                                                                v-bind:FieldDescription="'description'"
                                                                :SearchTitle="'Occurrence 12'"
                                                                v-bind:isConcatModalId="true"
                                                                :IsDisabled="isReadOnly"
                                                                v-bind:ConcatModalId="'iModalClaimOccurrenceSpan12'"
                                                                :GetValues="onCodeConditionOkModal"
                                                                :SearchFieldCode="'Code'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                                <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateFrom12')"
                                                                    :Model="Claim.occurrence.occurencedatefrom12"
                                                                    @input="Claim.occurrence.occurencedatefrom12 = $event"
                                                                    :Id="'DateFrom12'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdDateTime
                                                                    :Label="$t('PatientClaimList.DateTo12')"
                                                                    :Model="Claim.occurrence.occurencedateto12"
                                                                    @input="Claim.occurrence.occurencedateto12= $event"
                                                                    :Id="'DateTo12'"
                                                                    :Type="'date'"
                                                                    :isRequired="false"
                                                                    :isConfirm="false"
                                                                    :ReadOnly="isReadOnly">
                                                                </MdDateTime>
                                                        </b-col>
                                                    </b-row>


                                                    <MdTitle v-bind:Text="'Authorization'"  class="mb-1" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                                                    <b-row>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdEdit
                                                                v-bind:Label="$t('PatientClaimList.Authorization1')"
                                                                v-bind:TypeProp="'text'"
                                                                v-bind:Name="'Authorization1'"
                                                                v-bind:MaxLengthProp="25"
                                                                :isReadOnly="isReadOnly"
                                                                v-model="Claim.occurrence.authorization1"
                                                                v-bind:Id="'input_ClaimAuthorization1'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdEdit
                                                                v-bind:Label="$t('PatientClaimList.AuthorizationResubCorrectedClaim')"
                                                                v-bind:TypeProp="'text'"
                                                                v-bind:Name="'Authorization2'"
                                                                v-bind:MaxLengthProp="25"
                                                                :isReadOnly="isReadOnly"
                                                                v-model="Claim.occurrence.authorization2"
                                                                v-bind:Id="'input_ClaimAuthorization2'"/>
                                                        </b-col>
                                                        <b-col lg="4" md="4" sm="12">
                                                            <MdEdit
                                                                v-bind:Label="$t('PatientClaimList.AuthorizationResubVoidedClaim')"
                                                                v-bind:TypeProp="'text'"
                                                                v-bind:Name="'Authorization3'"
                                                                v-bind:MaxLengthProp="25"
                                                                :isReadOnly="isReadOnly"
                                                                v-model="Claim.occurrence.authorization3"
                                                                v-bind:Id="'input_ClaimAuthorization3'"/>
                                                        </b-col>
                                                    </b-row>


                                        </div>
                                    </div>
                                </div>
                            </div>

                    </b-collapse>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>

            <!--<ModalClaimOccAuthoCondition
                v-if="showModalClaim"
                v-bind:TitleWindow="$t('PatientClaimList.ModalOccAuthoCond')"
                @OnResetModal="Reset($event)"
                v-bind:Claim="Claim"
                @getCodeConditionOK="OnReturnOK($event)"
                @getCodeConditionCANCEL="OnReturnCancel($event)"
                v-bind:ModalId="'ModalIdClaimOcc'">
            </ModalClaimOccAuthoCondition>-->

            <!--<MdPatientDiagCodes v-if="activateModalDiagCodes"
                v-bind:ModalId="'ClaimModalDiagnosis'"
                v-bind:PatientCode="this.PatientCode || this.$route.params.id"
                v-bind:ReadOnly="isReadOnly"
                v-bind:OpenInModal="true"
                v-bind:TitleWindow="$t('Shared.Diagnoses')"
                @getCodeConditionOK="onOkDiag($event)"
                @getCancel="onCancel($event)"
            ></MdPatientDiagCodes>-->

        <DiagnosisMainModal v-if="activateModalDiagCodes"
            @getCancel="onCancel($event)"
            @UpdateDiagnosis="UpdateDiag"
            :TitleWindow="'Diagnosis'"
            :ModalId="'ModalIdDiagnosisMedications'"
            :ReadOnly="isReadOnly"
            :PatientCode="this.$route.params.id">
        </DiagnosisMainModal>



        </div>

        <div :class="IsNarrative ? 'space-actions SpaceClaim' : 'space-actions'"></div>
        <div class="page-actions">
        <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:Name="'btnClaimlist'"
            v-bind:ClassProp="'secondary mx-2 btn-login'"
            v-on:click="DiscardChanges"/>

        <MdButton
            v-bind:Label="$t('Shared.Save')"
            v-bind:ClassProp="(this.isReadOnly)?'primary mx-2':'primary btn-login mx-2'"
            v-on:click="ClickSaveCall"
            v-bind:isReadOnly="isReadOnly"
            v-bind:Name="'btn_save_PatientClaim'"/>
    </div>

    </div>








</div>
</template>

<script>
let elemSaveBtn = '';
import EnumService from '@/services/enum.service'
import { EventBus } from '@/event-bus.js';
import PatientService from '@/services/patient.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils'
import Permission from '@/common/Permission'
import GlobalService from '@/services/global.service'
//import moment from "moment";
import ClaimList from '@/services/claimlist.service';
import InsuranceService from "@/services/insurance.service";

export default {
  name: 'Claim',
     beforeRouteLeave(to, from, next) {
	if (!this.isReadOnly && this.pendingChanges) {
		this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
          title: this.$t('claimbatchList.Claim'),
          okTitle: this.$t('Shared.BtnSave'),
          cancelTitle: this.$t('Shared.BtnDismiss'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning'
        })
          .then(value => {
            if(!value){
              next();
            } else {
              this.DoAction();
              next();
            }
          })
	} else {
		next()
	}
    },
  mixins: [ShowMessage, DBFunctions, Permission],
  props:{
    PatientCode:String
  },
  data(){
    return{
        DocInd:"",
        ClickSave:false,
        pendingChanges: false,
        isDiagCodeValid:true,
        isDayUnitValid:true,
        isUnitPriceValid:true,
        isChargesValid:true,
        isCptHcpcsValid:true,
        showModalClaim:false,
        activateModalDiagCodes:false,
        DocIndList:EnumService.ClaimDocIndList,
        PhotoObj:{},
        DiagList:[],
        IsNarrative:false,
        Info:{},
        InsuranceList:[],
        PayTypeList:[{code:"CHECK",name:"CHECK"},{code:"CASH",name:"CASH"},{code:"CREDIT",name:"CREDIT"},{code:"DEBIT",name:"DEBIT"}],
        ApplyCr:false,
        IssLineNoDescription:"",
        DocIndDescription:"",
        PosDescription:"",
        CPTREVCODEDescription:"",
        SuperBillDescription:"",
        DiagDescription:"",
        HCPCSDescription:"",
        FacilityDescription:"",
        TerInsuranceNoDescription:"",
        ValueCodeDescription:"",
        SecInsuranceNoDescription:"",
        DoctorDescription:"",
        DoctorCodeRefDescription:"",
        PrimInsuranceNoDescription:"",
        DateFrom:null,
        DateTo:null,
        Mode:this.$attrs.editMode,
        isReadOnly:false,
        PatientTitle:{
        programName:'',
        fullName:'',
        admitDate:'',
        dischargeDate:'',
        dob:'',
        activitytypename:'',
        startdatetime:'',
        ageFormatted:''
      },
        OptionsRightMenu:{
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false,
            PatientCode:''
        },

       patient:{},
        cptHcpcsDescription:"",

        Claim:{
            narrative:"",
            cptHcpcs:"",
            isslineno:0,
            masterlineno:0,
            docInd:"9",
            Patientcode:this.PatientCode || this.$route.params.id,
            hcpcsCode:"",
            hcpcsDescription:"",
            posCode:"",
            printflag:0,
            sendflag:false,
            sendfalg1:false,
            paidfull:false,
            repeatdone:null,
            repeatnumber:null,
            paymentpercent:0,
            diagind:0,
            autho:"",
            insuranceCode:"",
            insuranceCodeDescription:"",
            insuranceCode1:"",
            amtapproved:0,
            dateFrom:null,
            datepaid:null,
            dateTo:null,
            electronic:false,
            printFlagSec:null,
            printFlagTer:null,
            diagInd1:null,
            diagInd2:null,
            diagInd3:null,
            discount:null,
            paidamt:0,
            insuranceCode1Description:"",
            insuranceCode2:"",
            insuranceCode2Description:"",
            SuperBill:"",
            CPTREVCode:"",
            HCPCS:"",
            diagCode:"",
            dayUnit:parseFloat(1.00).toFixed(2),
            unitPrice:null,
            charges:parseFloat(0.00).toFixed(2),
            paid:0,
            valueCode:"",
            amount:0,
            valueCodeAmt:null,
            clia:"",
            primInsuranceNo:"",
            secInsuranceNo:"",
            terInsuranceNo:"",
            Md:"",
            RefMd:"",
            facility:"",
            PayRef:"",
            Credit:"",
            PayType:"",
            PayAmount:"",
            conditionCode1:"",
            conditionCode1Description:"",
            conditionCode2:"",
            conditionCode2Description:"",
            conditionCode3:"",
            conditionCode3Description:"",
            conditionCode4:"",
            conditionCode4Description:"",
            conditionCode5:"",
            conditionCode5Description:"",
            conditionCode6:"",
            conditionCode6Description:"",
            conditionCode7:"",
            conditionCode7Description:"",
            occurrence:{
                occurencecode1:"",
                occurencecode1description:"",
                occurencecode2:"",
                occurencecode2description:"",
                occurencecode3:"",
                occurencecode3description:"",
                occurencecode4:"",
                occurencecode4description:"",
                occurencecode5:"",
                occurencecode5description:"",
                occurencecode6:"",
                occurencecode6description:"",
                occurencecode7:"",
                occurencecode7description:"",
                occurencecode8:"",
                occurencecode8description:"",
                occurencecode9:"",
                occurencecode9description:"",

                occurencedate1:null,
                occurencedate2:null,
                occurencedate3:null,
                occurencedate4:null,
                occurencedate5:null,
                occurencedate6:null,
                occurencedate7:null,
                occurencedate8:null,
                occurencedate9:null,

                authorization1:"",
                authorization2:"",
                authorization3:"",


                occurencedatefrom1:null,
                occurencedatefrom2:null,
                occurencedatefrom3:null,
                occurencedatefrom4:null,
                occurencedatefrom5:null,
                occurencedatefrom6:null,
                occurencedatefrom7:null,
                occurencedatefrom8:null,
                occurencedatefrom9:null,
                occurencedatefrom10:null,
                occurencedatefrom11:null,
                occurencedatefrom12:null,

                occurencedateto1:null,
                occurencedateto2:null,
                occurencedateto3:null,
                occurencedateto4:null,
                occurencedateto5:null,
                occurencedateto6:null,
                occurencedateto7:null,
                occurencedateto8:null,
                occurencedateto9:null,
                occurencedateto10:null,
                occurencedateto11:null,
                occurencedateto12:null,

                occurencespancode1:"",
                occurencespancode1description:"",
                occurencespancode2:"",
                occurencespancode2description:"",
                occurencespancode3:"",
                occurencespancode3description:"",
                occurencespancode4:"",
                occurencespancode4description:"",
                occurencespancode5:"",
                occurencespancode5description:"",
                occurencespancode6:"",
                occurencespancode6description:"",
                occurencespancode7:"",
                occurencespancode7description:"",
                occurencespancode8:"",
                occurencespancode8description:"",
                occurencespancode9:"",
                occurencespancode9description:"",
                occurencespancode10:"",
                occurencespancode10description:"",
                occurencespancode11:"",
                occurencespancode11description:"",
                occurencespancode12:"",
                occurencespancode12description:"",
            }
        }

    }
  },

  methods:{

   /* async getDiagnosisByPatientCode() {
            await PatientService
                .getDiagnosisListByPatientCode(this.$route.params.id)
                .then((response) => {
                    if (response.data) {
                        this.DiagList = response.data;
                    }
                })
                .catch(error => {
                   this.showResponseErrorMessage(error);
                });
        },*/

    UpdateDiag(){
        this.activateModalDiagCodes = false;
        this.GetVisitDiagnosisCodes();
    },

    ChangeDropDownDocInd(item){
        this.Claim.docInd = item ? item.value : null;
        this.IsNarrative = this.Claim.docInd === "6" ? true :false;
        if(!this.IsNarrative){
            this.Claim.narrative = "";
        }
    },

    onCancel(){
        this.activateModalDiagCodes = false;
    },
    onOkDiag(){
        this.activateModalDiagCodes = false;
    },

    OpenDiagnosis(){
        this.activateModalDiagCodes = true;
    },

  OpenModalOccurAuthoCond(){
    this.showModalClaim = true;
  },

  Reset(){
     this.showModalClaim = false;
  },

  OnReturnOK(){
    this.showModalClaim = false;
  },

  OnReturnCancel(){
    this.showModalClaim = false;
  },

  ChangeUnit(){
    if(this.Claim.cptHcpcs !== null && this.Claim.cptHcpcs !== ''){
        this.Claim.charges =  parseFloat(this.Claim.dayUnit * this.Claim.unitPrice).toFixed(2);
    }
  },

  ChangeDay(){
     if(this.Claim.cptHcpcs !== null && this.Claim.cptHcpcs !== ''){
        this.Claim.charges =  parseFloat(this.Claim.dayUnit * this.Claim.unitPrice).toFixed(2);
    }
  },

    label(){

    },

    ChangeDropDownDiag(item){
        this.Claim.diagCode = item ? item.code : null;
        this.isDiagCodeValid = (this.Claim.diagCode === null || this.Claim.diagCode === "") ? false :true;
    },

    ChangeDropDownPayType(){

    },

    ChangeApplyCR(){

    },

    ValidateRequired(){
        this.isCptHcpcsValid = (this.Claim.cptHcpcs === null || this.Claim.cptHcpcs === "") ? false :true;
        this.isDiagCodeValid = (this.Claim.diagCode === null || this.Claim.diagCode === "") ? false :true;
        this.isDayUnitValid =  (this.Claim.dayUnit === null || this.Claim.dayUnit === "") ? false :true;
        this.isUnitPriceValid = (this.Claim.unitPrice === null || this.Claim.unitPrice === "") ? false :true;
        this.isChargesValid = (this.Claim.charges === null || this.Claim.charges === "") ? false :true;

        return  this.isCptHcpcsValid && this.isDiagCodeValid && this.isDayUnitValid && this.isUnitPriceValid && this.isChargesValid;

    },

    DoAction(){
        if(!this.$store.state.isPatientClaimsEHRReadOnly){
             if(this.ValidateRequired()){
                this.$attrs.editMode ? this.UpdateClaim() : this.AddClaim();
            }else{
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.CheckRedLabeledFields'),"errorAutoHide");
            }
        }else{
            this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.SaveReadOnly'),"errorAutoHide");
        }


    },


    ClickSaveCall(){
        this.ClickSave = true;
        this.DoAction();
    },

    UpdateClaim(){
        ClaimList.Update(this.$route.params.recId,this.Claim)
         .then((response) => {
            if(response.status == '200'){
                 this.pendingChanges = false;
               setTimeout(() =>
                  this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                     title: this.$t('Msg.Success'),
                     autoHideDelay: 5000,
                     variant: "success"
                  })
                  , 50);

                 if(this.ClickSave){
                    this.$router.push({name: "patientclaimList",params: { id: this.PatientCode || this.$route.params.id}});
                 }
            }
            })
         .catch((error) => {
            this.showResponseErrorMessage(error);
         });

    },

    AddClaim(){
         ClaimList.Add(this.Claim)
         .then((response) => {
            if(response.status == '200'){
                 this.pendingChanges = false;
               setTimeout(() =>
                  this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                     title: this.$t('Msg.Success'),
                     autoHideDelay: 5000,
                     variant: "success"
                  })
                  , 50);

                    if(this.ClickSave){
                        this.$router.push({name: "patientclaimList",params: { id: this.PatientCode || this.$route.params.id}});
                    }
                }
            })
         .catch((error) => {
            this.showResponseErrorMessage(error);
         });

      },

     async getPatient() {
           await PatientService.get(this.PatientCode || this.$route.params.id)
            .then((response) => {
                if(response.status == '200' && response.data){
                    this.patient = response.data;
                    if(this.patient){
                        this.patient.sgDate = this.patient.sgDate ? Utils.formatterDateToString(this.patient.sgDate) : null;
                        this.patient.consultDate = this.patient.consultDate ? Utils.formatterDateToString(this.patient.consultDate) : null;
                    }
                }
            })
            .catch((error) => {
              if (!error.response) {
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
        },


         getClaim() {
            ClaimList.getClaim(this.$route.params.recId)
            .then((response) => {
                if(response.status == '200' && response.data){
                    this.Claim = response.data;
                    this.PosDescription = this.Claim.posDescription;
                    this.cptHcpcsDescription = this.Claim.cptHcpcsDescription;
                    this.DoctorDescription = this.Claim.doctorDescription;
                    this.PrimInsuranceNoDescription = this.Claim.primInsuranceNoDescription;
                    this.DoctorCodeRefDescription = this.Claim.doctorCodeRefDescription;
                    this.FacilityDescription =  this.Claim.facilityDescription;
                    this.Claim.charges = parseFloat(this.Claim.charges).toFixed(2);
                    this.Claim.dayUnit = parseFloat(this.Claim.dayUnit).toFixed(2);
                    this.Claim.unitPrice = parseFloat(this.Claim.unitPrice).toFixed(2);
                    this.Claim.paid = parseFloat(this.Claim.paid).toFixed(2);
                    this.IsNarrative = this.Claim.docInd === "6" ? true : false;
                }
            })
            .catch((error) => {
              if (!error.response) {
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
        },

    DiscardChanges(){
        this.$router.push({ name: 'patientclaimList', params: { id: this.PatientCode || this.$route.params.id }});
    },

     ChangeDateFromSpan1(){
    },

    ChangeDateToSpan1(){
    },
    ChangeDateFromSpan2(){
    },

    ChangeDateToSpan2(){
    },
    ChangeDateFromSpan3(){
    },

    ChangeDateToSpan3(){
    },
    ChangeDateFromSpan4(){
    },

    ChangeDateToSpan4(){
    },
    ChangeDateFromSpan5(){
    },

    ChangeDateToSpan5(){
    },
    ChangeDateFromSpan6(){
    },

    ChangeDateToSpan6(){
    },
    ChangeDateFromSpan7(){
    },

    ChangeDateToSpan7(){
    },
    ChangeDateFromSpan8(){
    },

    ChangeDateToSpan8(){
    },
    ChangeDateFromSpan9(){
    },

    ChangeDateToSpan9(){
    },
    ChangeDateFromSpan10(){
    },

    ChangeDateToSpan10(){
    },
    ChangeDateFromSpan11(){
    },

    ChangeDateToSpan11(){
    },
    ChangeDateFromSpan12(){
    },

    ChangeDateToSpan12(){
    },

    ChangeDate1(){

    },

    ChangeDate2(){

    },

    ChangeDate3(){

    },
    ChangeDate4(){

    },
    ChangeDate5(){

    },
    ChangeDate6(){

    },
    ChangeDate7(){

    },
    ChangeDate8(){

    },
    ChangeDate9(){

    },

 onCodeConditionOk(result){
            var type = result.FieldName;

            if(type.indexOf('PlaceOfServicesPos') >= 0){
                this.Claim.posCode = result.code;
                this.Claim.PosDescription = result.description;
            }

            else if(type.indexOf('CPTs') >= 0){
                this.Claim.cptHcpcs = result.code;
                this.cptHcpcsDescription = result.description;

                if(this.Claim.dayUnit && this.Claim.unitPrice){
                   this.Claim.charges = parseFloat(this.Claim.dayUnit * this.Claim.unitPrice).toFixed(2);
                }
            }

            else if(type.indexOf('HCPCS') >= 0){
                this.Claim.hcpcsCode = result.code;
                this.Claim.hcpcsDescription = result.description;
            }

            else if(type.indexOf('ValueCodes') >= 0){
                this.Claim.valueCode = result.code;
                this.Claim.valueCodeDescription = result.description;
            }

            else if(type.indexOf('PrimaryInsurance') >= 0){
                this.Claim.insuranceCode = result.code;
                this.Claim.insuranceCodeDescription = result.description;
            }

            else if(type.indexOf('SecInsurance') >= 0){
                this.Claim.insuranceCode1 = result.code;
                this.Claim.insuranceCode1Description = result.description;
            }

            else if(type.indexOf('TerInsurance') >= 0){
                this.Claim.insuranceCode2 = result.code;
                this.Claim.insuranceCode2Description = result.description;
            }

            else if(type === 'Doctors'){
                this.Claim.doctorCode = result.code;
                this.DoctorDescription = result.description;
            }

            else if(type === 'DoctorsRef'){
                this.Claim.doctorCodeRef = result.code;
                this.DoctorCodeRefDescription = result.description;
            }

            else if(type.indexOf('Facilities') >= 0){
                this.Claim.facilityCode = result.code;
                this.FacilityDescription = result.description;
            }

            else if(type.indexOf('Modifier') >= 0){
                 switch (type) {
                    case "Modifier1":
                        this.Claim.modifier1 = result.code;
                        this.Claim.modifier1Description = result.description;
                    break;
                    case "Modifier2":
                        this.Claim.modifier2 = result.code;
                        this.Claim.modifier2Description = result.description;
                    break;
                    case "Modifier3":
                        this.Claim.modifier3 = result.code;
                        this.Claim.modifier3Description = result.description;
                    break;
                    default:
                        this.Claim.modifier4 = result.code;
                        this.Claim.modifier4Description = result.description;
                }
            }

        },

       async getDateTime() {
        if(!this.$attrs.editMode){
            await GlobalService.getDateTime()
                .then((response) => {
                if (response.data) {
                        this.Claim.dateFrom = response.data;
                        this.Claim.dateTo = response.data;
                }
            })
            .catch(error => {
                if (error.response) {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
            });
            }
      },

      PopulateInsurances(arr){
        if(arr.length > 0){
            arr.forEach(element => {
            if(element.insuranceTypeCode === "P"){
                this.Claim.insuranceCode = element.insuranceCode;
                this.Claim.insuranceCodeDescription = element.insuranceName;
                this.Claim.primInsuranceNo = element.policyNo;
            }
            if(element.insuranceTypeCode === "S"){
                this.Claim.insuranceCode1 = element.insuranceCode;
                this.Claim.insuranceCode1Description = element.insuranceName;
                this.Claim.secInsuranceNo = element.policyNo;
            }
            if(element.insuranceTypeCode === "T"){
                this.Claim.insuranceCode2 = element.insuranceCode;
                this.Claim.insuranceCode2Description = element.insuranceName;
                this.Claim.terInsuranceNo = element.policyNo;
            }
        });
        }
      },

      getSearchInsurances() {
        let patientCodes = [];
        patientCodes.push(this.PatientCode || this.$route.params.id);
        var params = {
            PageNumber:null,
            PageSize:null,
            PatientCodeList:patientCodes,
            InsTypeList:["P","S","T"]
        }
        InsuranceService.getAllInsuranceSearch(params, true)
            .then((response) => {
            if(response.status == '200' && response.data){
                this.InsuranceList = response.data;
                this.PopulateInsurances(this.InsuranceList);
            }

            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
      },

      async GetVisitDiagnosisCodes() {
         await ClaimList.GetVisitDiagnosisCodes(this.PatientCode || this.$route.params.id,null)
            .then((response) => {
               if (response.data) {
                   var diag = response.data;

                   diag.forEach(element => {
                        element.code = element.code ? element.code.trim() :"";
                        element.description = element.description ? element.description.trim() :"";
                   });

                    this.DiagList = diag;
               }
         })
         .catch(error => {
            if (error.response) {
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         });
      },

    checkUserAction() {
        if (elemSaveBtn.disabled) {
          elemSaveBtn.removeAttribute('disabled');
        }
    },

    beforeWindowUnload(e) {
        if (this.pendingChanges) {
            e.preventDefault()
            e.returnValue = ''
        }
    },


    onCodeConditionOkModal(result){
      var type = result.FieldName;
           if(type.indexOf('Condition') >= 0){
                 switch (type) {
                    case "Condition1":
                        this.Claim.conditionCode1 = result.code;
                        this.Claim.conditionCode1Description = result.description;
                    break;
                    case "Condition2":
                        this.Claim.conditionCode2 = result.code;
                        this.Claim.conditionCode2Description = result.description;
                    break;
                    case "Condition3":
                        this.Claim.conditionCode3 = result.code;
                        this.Claim.conditionCode3Description = result.description;
                    break;
                    case "Condition4":
                        this.Claim.conditionCode4 = result.code;
                        this.Claim.conditionCode4Description = result.description;
                    break;
                    case "Condition5":
                        this.Claim.conditionCode5 = result.code;
                        this.Claim.conditionCode5Description = result.description;
                    break;
                    case "Condition6":
                        this.Claim.conditionCode6 = result.code;
                        this.Claim.conditionCode6Description = result.description;
                    break;
                    default:
                        this.Claim.conditionCode7 = result.code;
                        this.Claim.conditionCode7Description = result.description;
                }
            }else if(type.indexOf('Occurrence') >= 0){
                 switch (type) {
                    case "Occurrence1":
                        this.Claim.occurrence.occurencecode1 = result.code;
                        this.Claim.occurrence.occurencecode1description = result.description;
                    break;
                    case "Occurrence2":
                        this.Claim.occurrence.occurencecode2 = result.code;
                        this.Claim.occurrence.occurencecode2description = result.description;
                    break;
                    case "Occurrence3":
                        this.Claim.occurrence.occurencecode3 = result.code;
                        this.Claim.occurrence.occurencecode3description = result.description;
                    break;
                    case "Occurrence4":
                        this.Claim.occurrence.occurencecode4 = result.code;
                        this.Claim.occurrence.occurencecode4description = result.description;
                    break;
                    case "Occurrence5":
                        this.Claim.occurrence.occurencecode5 = result.code;
                        this.Claim.occurrence.occurencecode5description = result.description;
                    break;
                    case "Occurrence6":
                        this.Claim.occurrence.occurencecode6 = result.code;
                        this.Claim.occurrence.occurencecode6description = result.description;
                    break;
                    case "Occurrence7":
                        this.Claim.occurrence.occurencecode7 = result.code;
                        this.Claim.occurrence.occurencecode7description = result.description;
                    break;
                    case "Occurrence8":
                        this.Claim.occurrence.occurencecode8 = result.code;
                        this.Claim.occurrence.occurencecode8description = result.description;
                    break;
                    default:
                        this.Claim.occurrence.occurencecode9 = result.code;
                        this.Claim.occurrence.occurencecode9description = result.description;
                }
            }else if(type.indexOf('Ospan') >= 0){
                 switch (type) {
                    case "Ospan1":
                        this.Claim.occurrence.occurencespancode1 = result.code;
                        this.Claim.occurrence.occurencespancode1description = result.description;
                    break;
                    case "Ospan2":
                        this.Claim.occurrence.occurencespancode2 = result.code;
                        this.Claim.occurrence.occurencespancode2description = result.description;
                    break;
                    case "Ospan3":
                        this.Claim.occurrence.occurencespancode3 = result.code;
                        this.Claim.occurrence.occurencespancode3description = result.description;
                    break;
                    case "Ospan4":
                        this.Claim.occurrence.occurencespancode4 = result.code;
                        this.Claim.occurrence.occurencespancode4description = result.description;
                    break;
                    case "Ospan5":
                        this.Claim.occurrence.occurencespancode5 = result.code;
                        this.Claim.occurrence.occurencespancode5description = result.description;
                    break;
                    case "Ospan6":
                        this.Claim.occurrence.occurencespancode6 = result.code;
                        this.Claim.occurrence.occurencespancode6description = result.description;
                    break;
                    case "Ospan7":
                        this.Claim.occurrence.occurencespancode7 = result.code;
                        this.Claim.occurrence.occurencespancode7description = result.description;
                    break;
                    case "Ospan8":
                        this.Claim.occurrence.occurencespancode8 = result.code;
                        this.Claim.occurrence.occurencespancode8description = result.description;
                    break;
                    case "Ospan9":
                        this.Claim.occurrence.occurencespancode9 = result.code;
                        this.Claim.occurrence.occurencespancode9description = result.description;
                    break;
                    case "Ospan10":
                        this.Claim.occurrence.occurencespancode10 = result.code;
                        this.Claim.occurrence.occurencespancode10description = result.description;
                    break;
                    case "Ospan11":
                        this.Claim.occurrence.occurencespancode11 = result.code;
                        this.Claim.occurrence.occurencespancode11description = result.description;
                    break;
                    default:
                        this.Claim.occurrence.occurencespancode12 = result.code;
                        this.Claim.occurrence.occurencespancode12description = result.description;
                }
            }

    },

     async GetPatientByCode(){
      var infoList = await this.getInfoTitle(this.PatientCode || this.$route.params.id);
      if(infoList.length > 0){
        this.PatientTitle.programName = '';
        this.PatientTitle.admitDate = '';
        this.PatientTitle.dischargeDate = '';

        const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

        if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
        if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
        if (age) this.PatientTitle.age = age;
        if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;
      }
    },
  },

  created(){
     this.GetVisitDiagnosisCodes();
       EventBus.$on("onChanged", function (e) {
          this.pendingChanges = e.Changed
          this.checkUserAction();
     }.bind(this));
     window.addEventListener('beforeunload', this.beforeWindowUnload)
  },

  async mounted(){
    setTimeout( function() {
         elemSaveBtn = document.getElementById('btn_save_PatientClaim');
         elemSaveBtn.setAttribute('disabled','');
      }, 10, this );

    this.OptionsRightMenu.ItemsList = EnumService.PatientItems;
    this.OptionsRightMenu.visible = true;
    this.$emit("getVisibleMenu", this.OptionsRightMenu);
    this.isReadOnly = await this.$store.state.isPatientClaimsEHRReadOnly;
    await this.GetPatientByCode();
    await this.getPatient();
    await this.getDateTime();
    if(this.$attrs.editMode){
         this.getClaim();
    }else{
        this.getSearchInsurances();
        this.Claim.autho = this.patient.autho;
        this.Claim.doctorCode = this.patient.doctorcode;
        this.DoctorDescription = this.patient.doctorDescription;
        this.Claim.doctorCodeRef = this.patient.privdoctorcode;
        this.DoctorCodeRefDescription = this.patient.doctorPrivDescription;
        this.Claim.facilityCode = this.patient.facilitycode;
        this.FacilityDescription = this.patient.facilityname;
        this.Claim.conditionCode1 = this.patient.conditioncode1;
        this.Claim.conditionCode1Description = this.patient.conditionCode1Description;
        this.Claim.conditionCode2 = this.patient.conditioncode2;
        this.Claim.conditionCode2Description = this.patient.conditionCode2Description;
        this.Claim.conditionCode3 = this.patient.conditioncode3;
        this.Claim.conditionCode3Description = this.patient.conditionCode3Description;
        this.Claim.conditionCode4 = this.patient.conditioncode4;
        this.Claim.conditionCode4Description = this.patient.conditionCode4Description;
        this.Claim.conditionCode5 = this.patient.conditioncode5;
        this.Claim.conditionCode5Description = this.patient.conditionCode5Description;
        this.Claim.conditionCode6 = this.patient.conditioncode6;
        this.Claim.conditionCode6Description = this.patient.conditionCode6Description;
        this.Claim.conditionCode7 = this.patient.conditioncode7;
        this.Claim.conditionCode7Description = this.patient.conditionCode7Description;
    }


  },

  beforeDestroy () {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },

};
</script>

<style scoped>
.SpaceClaim{
 height: calc(100vh - 30px);
}
</style>



